import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-4" }
const _hoisted_4 = { class: "default-table-area style-two default-table-width" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table align-middle" }
const _hoisted_7 = { class: "text-body" }
const _hoisted_8 = { class: "form-check" }
const _hoisted_9 = {
  class: "position-relative top-2 ms-1",
  for: "flexCheckDefault12"
}
const _hoisted_10 = { class: "flex-shrink-0" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "flex-grow-1 ms-2 position-relative top-1" }
const _hoisted_13 = { class: "mb-0 fs-14 fw-medium" }
const _hoisted_14 = { class: "text-body" }
const _hoisted_15 = { class: "text-body" }
const _hoisted_16 = { class: "text-body" }
const _hoisted_17 = { class: "text-body" }
const _hoisted_18 = {
  key: 0,
  class: "badge bg-primary bg-opacity-10 text-primary p-2 fs-12 fw-normal"
}
const _hoisted_19 = {
  key: 1,
  class: "badge bg-danger bg-opacity-10 text-danger p-2 fs-12 fw-normal"
}
const _hoisted_20 = { class: "d-flex align-items-center gap-1" }
const _hoisted_21 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_22 = { class: "material-symbols-outlined fs-16 text-primary" }
const _hoisted_23 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_24 = { class: "material-symbols-outlined fs-16 text-body" }
const _hoisted_25 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_26 = { class: "material-symbols-outlined fs-16 text-danger" }
const _hoisted_27 = { class: "p-4 pt-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "position-relative table-src-form me-0",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Search here",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event))
          }, null, 512), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y" }, " search ", -1))
        ], 32),
        _cache[3] || (_cache[3] = _createElementVNode("button", {
          class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg",
          "data-bs-toggle": "offcanvas",
          "data-bs-target": "#addNewContactModal",
          "aria-controls": "addNewContactModal"
        }, [
          _createElementVNode("span", { class: "py-sm-1 d-block" }, [
            _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block me-1" }),
            _createElementVNode("span", null, "Add New Contact")
          ])
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("div", { class: "form-check" }, [
                    _createElementVNode("input", {
                      class: "form-check-input position-relative top-1",
                      type: "checkbox",
                      value: "",
                      id: "flexCheckDefault7"
                    }),
                    _createElementVNode("label", {
                      class: "position-relative top-2 ms-1",
                      for: "flexCheckDefault7"
                    }, " ID ")
                  ])
                ]),
                _createElementVNode("th", { scope: "col" }, "User"),
                _createElementVNode("th", { scope: "col" }, "Email"),
                _createElementVNode("th", { scope: "col" }, "Phone"),
                _createElementVNode("th", { scope: "col" }, "Last Contacted"),
                _createElementVNode("th", { scope: "col" }, "Company"),
                _createElementVNode("th", { scope: "col" }, "Lead Score"),
                _createElementVNode("th", { scope: "col" }, "Status"),
                _createElementVNode("th", { scope: "col" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _cache[4] || (_cache[4] = _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault12"
                      }, null, -1)),
                      _createElementVNode("label", _hoisted_9, _toDisplayString(item.id), 1)
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, {
                      to: "/help-desk/agents",
                      class: "d-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("img", {
                            src: item.user.image,
                            class: "wh-34 rounded-circle",
                            alt: "user"
                          }, null, 8, _hoisted_11)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("h6", _hoisted_13, _toDisplayString(item.user.name), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.email), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(item.phone), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(item.lastContacted), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(item.company), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(item.leadScore), 1),
                  _createElementVNode("td", null, [
                    (item.status.active)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Active"))
                      : _createCommentVNode("", true),
                    (item.status.deactive)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Deactive"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("button", _hoisted_21, [
                        _createElementVNode("i", _hoisted_22, _toDisplayString(item.action.view), 1)
                      ]),
                      _createElementVNode("button", _hoisted_23, [
                        _createElementVNode("i", _hoisted_24, _toDisplayString(item.action.edit), 1)
                      ]),
                      _createElementVNode("button", _hoisted_25, [
                        _createElementVNode("i", _hoisted_26, _toDisplayString(item.action.delete), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_Pagination, { items: "10" })
        ])
      ])
    ])
  ]))
}